import { useEffect, useState } from "react";
import { Card, CardContent } from "../../../../components/ui/card";
import { Separator } from "../../../../components/ui/separator";
import { getFundDbName } from "../../../../utils/funds";
import { BaixaOperationSection } from "./components/baixa-operation-section";
import { useBaixaResolution } from "./hooks/use-baixa-resolution";

export default function FundBaixaResolution() {
  const {
    baixaList: agilityList,
    isLoading: isLoadingAgility,
    startDoc: startDocAgility,
    submitDb: submitDbAgility,
    isStartingDoc: isStartingDocAgility,
    isSubmittingDb: isSubmittingDbAgility,
  } = useBaixaResolution({
    fundName: getFundDbName("agility"),
    ops: "agility",
  });

  const {
    baixaList: muveList,
    isLoading: isLoadingMuve,
    startDoc: startDocMuve,
    submitDb: submitDbMuve,
    isStartingDoc: isStartingDocMuve,
    isSubmittingDb: isSubmittingDbMuve,
  } = useBaixaResolution({
    fundName: getFundDbName("muve"),
    ops: "muve",
  });

  const {
    baixaList: indriveList,
    isLoading: isLoadingIndrive,
    startDoc: startDocIndrive,
    submitDb: submitDbIndrive,
    isStartingDoc: isStartingDocIndrive,
    isSubmittingDb: isSubmittingDbIndrive,
  } = useBaixaResolution({
    fundName: getFundDbName("indrive"),
    ops: "indrive",
  });

  return (
    <div className="p-6">
      <div className="mb-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold text-foreground">
              Baixa de Créditos
            </h1>
            <p className="text-muted-foreground mt-1">
              Resolver pendências dos checkouts
            </p>
          </div>
        </div>
      </div>

      <div className="space-y-8">
        <BaixaOperationSection
          operationName="agility"
          baixaList={agilityList}
          isLoading={isLoadingAgility}
          onStartDoc={startDocAgility}
          onSubmitDb={submitDbAgility}
          isStartingDoc={isStartingDocAgility}
          isSubmittingDb={isSubmittingDbAgility}
        />

          <Separator className="my-8" />

          <BaixaOperationSection
            operationName="muve"
            baixaList={muveList}
            isLoading={isLoadingMuve}
            onStartDoc={startDocMuve}
            onSubmitDb={submitDbMuve}
            isStartingDoc={isStartingDocMuve}
            isSubmittingDb={isSubmittingDbMuve}
          />

          <Separator className="my-8" />

          <BaixaOperationSection
            operationName="indrive"
            baixaList={indriveList}
            isLoading={isLoadingIndrive}
            onStartDoc={startDocIndrive}
            onSubmitDb={submitDbIndrive}
            isStartingDoc={isStartingDocIndrive}
            isSubmittingDb={isSubmittingDbIndrive}
          />
        </div>
    </div>
  );
}
